// Storage flag for debugging in the production
const DEV_STORAGE_KEY = 'dev';

const DEV_REACT_APP_ENV = 'development';

export const isProductionMode = () => {
  try {
    if (window.localStorage.getItem(DEV_STORAGE_KEY) === DEV_REACT_APP_ENV) {
      return false;
    }
  } catch (e) {
    // do  nothing
  }
  return process.env.REACT_APP_ENV !== DEV_REACT_APP_ENV;
};
